export enum RatingTablesModes {
  CLASSIC = 'classic',
  ONEVONE = '1v1',
}
